import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';

@Component({
  templateUrl: './park-notifications-view.html',
  selector: 'park-notifications-view'
})

export class ParkNotificationsViewComponent {
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  @Input() settings;

  constructor() {
    //
  }

  public setEditMode() {
    this.getSearchStatusChange.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/settings/notifications/park-notifications-view.component.ts